module.exports = function getResource(label, vars = []) {
    let resources = {
        modalTitle: 'Préférences de confidentialité',
        save: 'Enregistrer les préférences',
        allowCookies: 'Autoriser les témoins publicitaires',
        disallowCookies: 'Ne pas autoriser les témoins publicitaires'
    };

    return resources[label];
};
